
import { Button } from "@/components/ui/button";

interface PolicyFormHeaderProps {
  onCancel: () => void;
  clientName?: string;
}

export const PolicyFormHeader = ({ onCancel, clientName }: PolicyFormHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center">
        <h2 className="text-lg font-semibold text-primary">Create New Policy</h2>
        {clientName && (
          <span className="ml-2 text-gray-600">
            for <span className="font-medium">{clientName}</span>
          </span>
        )}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onCancel}
        className="text-neutral hover:text-primary"
      >
        Cancel
      </Button>
    </div>
  );
};
